import React, { Component } from 'react';
import { projects } from 'data/projects.json';

import Carousel from 'components/carousel';
import Iphone from 'components/iphone';
import Macbook from 'components/macbook';
import OutboundLink from 'components/outbound-link';
import Wrapper from 'components/wrapper';
import { ProjectDescription, ProjectIntro, ProjectPage } from 'components/project';
import 'gsap'
import styles from './styles.module.css';
import SocialShare from 'components/social';

import coverImage from 'components/project/img/SociallyFox.jpg';
/*
const images = [
  {
    src: require('./img/dining.jpg'),
    description: 'SociallyFox dining',
  },
  {
    src: require('./img/home.jpg'),
    description: 'SociallyFox home',
  },
  {
    src: require('./img/services.jpg'),
    description: 'SociallyFox services',
  },
  {
    src: require('./img/store.jpg'),
    description: 'SociallyFox store',
  },
  {
    src: require('./img/whats-on.jpg'),
    description: 'SociallyFox what\'s on',
  },
];
*/
const mobileImages = [
  {
    src: require('./img/prez.png'),
    description: 'SociallyFox article mobile',
  },
  {
    src: require('./img/note.png'),
    description: 'SociallyFox directions mobile',
  },
  {
    src: require('./img/param.png'),
    description: 'SociallyFox shopping mobile',
  },
];


export default class SociallyFox extends Component {
  constructor(props) {
    super(props);
  }

componentDidMount(){
    var tl = new TimelineLite()
    var mySplitText = new SplitText(this.textAnim, {type:"words,chars"})
     var chars = mySplitText.chars

    TweenLite.set(this.textAnim, {perspective:400});

    tl.staggerFrom(chars, 0.8, {opacity:0, scale:0, y:80, rotationX:180, transformOrigin:"0% 50% -50",  ease:Back.easeOut}, 0.01, "+=0");

}

  render() {
    const project = projects.find(_project => _project.slug === 'sociallyfox');

    const image = (
      <img src={coverImage} alt="Cover" />
    );

    const iphone = (
      <Iphone>
        <Carousel images={mobileImages} />
      </Iphone>
    );

    var textStyle= {
      textAlign: "left",
      fontSize: 20
    }

    var speStyle={
      fontWeight: 'bold',
      fontSize: 22
    }

    return (
      <ProjectPage project={project}>
        <ProjectIntro project={project} media={image} />
        <ProjectDescription
          media={iphone}
          appleUrl={project.appleUrl}
          googleUrl={project.googleUrl}
          >
          <h3>Comment être socialement meilleur ? </h3>

            <wrapper className={styles.sectionImg}>
              <div className={styles.imgPrez}>
                <img src={require('./img/list.png')} alt="chef" />
              </div>
              <p style={textStyle}>Une liste de gestes et de mots qui rend plus persuasif et populaire.</p>
            </wrapper>


            <wrapper className={styles.sectionImg}>
              <div className={styles.imgPrez}>
                <img src={require('./img/notif.png')} alt="aimer" />
              </div>
              <p style={textStyle}>Des notifications motivante qui vous serviront de rappel afin d'utilisers ces astuces.</p>
            </wrapper>


            <wrapper className={styles.sectionImg}>
              <div className={styles.imgPrez}>
                <img src={require('./img/progress.png')} alt="aimer" />
              </div>
              <p style={textStyle}>Des astuces progressivement de plus en plus compliqué mais adapté à votre niveau.</p>
            </wrapper>



          <wrapper className={styles.sectionImg}>
            <div className={styles.imgPrez}>
              <img src={require('./img/science.png')} alt="Science comportementale" />
            </div>
            <p style={textStyle}>Et inspiré par plusieurs livres de science comportementale.</p>
          </wrapper>


          <p>Par exemple dans Socially Fox, on y explique le <a href="https://fr.wikipedia.org/wiki/Pied-dans-la-porte">Pied-dans-la-porte</a>.</p>

        </ProjectDescription>
        <SocialShare
          urlToShare="http://layouceferie.fr/work/sociallyfox/"
          title="Socially Fox"
          description="Plus de 20 ruses pour vous aidez à être socialement bon dans votre vie quotidienne."
          />
      </ProjectPage>
    );
  }
}
/*
<Macbook>
  <Carousel images={images} />
</Macbook>
*/



// WEBPACK FOOTER //
// ./work/sociallyfox/index.jsx